import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { CKEditorModule } from 'ckeditor4-angular';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatTooltipModule} from '@angular/material/tooltip';

import { SiteService } from '@app-services/site.service';
// import { environment } from '../environments/environment';
import { environment } from '../environments/environment.prod';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationComponent } from './components/core/navigation/navigation.component';
import { HeaderComponent } from './components/core/header/header.component';
import { SiteComponent } from './components/site/site.component';
import { AddHospitalComponent } from './components/modals/add-hospital/add-hospital.component';
import { AddServiceComponent } from './components/modals/add-service/add-service.component';
import { AddUserComponent } from './components/modals/add-user/add-user.component';
import { EditDetailComponent } from './components/modals/edit-detail/edit-detail.component';
import { SiteDetailComponent } from './components/site-child/site-detail/site-detail.component';
import { ServiceDetailComponent } from './components/site-child/service-detail/service-detail.component';
import { UserManagerComponent } from './components/site-child/user-manager/user-manager.component';
import { LoginComponent } from './components/login/login.component';
import { ModalInputComponent, ModalInputDialogComponent } from './components/core/modal-input/modal-input.component';
import { MainPageComponent } from './components/core/main-page/main-page.component';
import { ConfirmComponent } from './components/modals/confirm/confirm.component';
import { ChangePasswordComponent } from './components/modals/change-password/change-password.component';
import { BrowseLogoComponent } from './components/modals/browse-logo/browse-logo.component';
import { LoadingScreenComponent } from './components/core/loading-screen/loading-screen.component';
import { EditUserSettingComponent } from './components/modals/edit-user-setting/edit-user-setting.component';
import { TermsComponent } from './components/mobile-info/terms/terms.component';
import { AboutusComponent } from './components/mobile-info/aboutus/aboutus.component';
import { PolicyComponent } from './components/mobile-info/policy/policy.component';
import { AlertMessageComponent } from './components/modals/alert-message/alert-message.component';
import {MatDatepickerModule} from '@angular/material/datepicker';

import * as firebase from 'firebase/app';
import { DateDialogComponent } from './components/core/date-dialog/date-dialog.component';
import { TimeslotDialogComponent } from './components/core/timeslot-dialog/timeslot-dialog.component';
import { ConsentDialogComponent } from './components/core/consent-dialog/consent-dialog.component';
import { TextDialogComponent } from './components/core/text-dialog/text-dialog.component';
import { QueuetypeComponent } from './components/modals/queuetype/queuetype.component';
import { InstructionComponent } from './components/modals/instruction/instruction.component';


firebase.initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    HeaderComponent,
    SiteComponent,
    UserManagerComponent,
    AddHospitalComponent,
    AddServiceComponent,
    AddUserComponent,
    EditDetailComponent,
    SiteDetailComponent,
    ServiceDetailComponent,
    LoginComponent,
    ModalInputComponent,
    ModalInputDialogComponent,
    MainPageComponent,
    ConfirmComponent,
    ChangePasswordComponent,
    BrowseLogoComponent,
    LoadingScreenComponent,
    EditUserSettingComponent,
    TermsComponent,
    AboutusComponent,
    PolicyComponent,
    AlertMessageComponent,
    DateDialogComponent,
    TimeslotDialogComponent,
    ConsentDialogComponent,
    TextDialogComponent,
    QueuetypeComponent,
    InstructionComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatDialogModule,
    MatInputModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatCardModule,
    MatGridListModule,
    MatExpansionModule,
    MatDividerModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    CKEditorModule
  ],
  exports: [
    AddHospitalComponent,
    AddServiceComponent,
    AddUserComponent,
    EditDetailComponent
  ],
  entryComponents: [
    ChangePasswordComponent,
    BrowseLogoComponent,
    AddHospitalComponent,
    AddServiceComponent,
    AddUserComponent,
    AlertMessageComponent,
    ConfirmComponent,
    EditDetailComponent,
    ModalInputDialogComponent,
    EditUserSettingComponent
  ],
  providers: [ SiteService ],
  bootstrap: [AppComponent]
})
export class AppModule { }
